<template>
  <p class="modal-card-title">二次利用規定</p>
</template>
